export default __webpack_public_path__ + "static/bluescope_seo-bc1ae46be5b67a54d0245a42afadc4ea.png";